import type { HTMLAttributes, ReactNode, FC } from 'react';
import React from 'react';
import type { HeadlineProps, TextProps } from '@oneaudi/unified-web-components';
import { Headline, Text } from '@oneaudi/unified-web-components';

interface BaseTypographyProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
}

type TextVariant = NonNullable<TextProps['variant']>;

type HeadlineVariant = NonNullable<HeadlineProps['variant']>;

interface TextComponentProps extends BaseTypographyProps {
  order?: TextVariant['order'];
  textStyle?: 'bold' | 'normal' | 'short';
}

interface HeadlineComponentProps extends BaseTypographyProps {
  order?: HeadlineVariant['order'];
  tag?:
    'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'span' | 'label' | 'figcaption' | 'caption';
  textStyle?: 'bold' | 'normal';
}

// TODO: write unit tests in the future. Right now this is a concept, that will discuss with DEVs
export const P: FC<TextComponentProps> = ({
  order = '1',
  textStyle = 'normal',
  children,
  ...props
}) => (
  <Text
    variant={{
      order,
      style: textStyle,
    }}
    {...props}
  >
    {children}
  </Text>
);

// TODO: write unit tests in the future. Right now this is a concept, that will discuss with DEVs
export const Title: FC<HeadlineComponentProps> = ({
  order = '1',
  tag = 'h1',
  textStyle = 'normal',
  children,
  ...props
}) => (
  <Headline
    tag={tag}
    variant={{
      order,
      type: 'headline',
      weight: textStyle,
    }}
    {...props}
  >
    {children}
  </Headline>
);
